export const ROUTE_CHANGED = 'ROUTE_CHANGED'

export const MARKET_INDICES_REFRESH = 'MARKET_INDICES_REFRESH'
export const UPDATE_LOCAL_SERVER_TIME_GAP = 'UPDATE_LOCAL_SERVER_TIME_GAP'

export const ADD_TRADE_STOCK = 'ADD_TRADE_STOCK'
export const DELETE_TRADE_STOCK = 'DELETE_TRADE_STOCK'
export const REFRESH_STOCK_DETAIL = 'REFRESH_STOCK_DETAIL'
export const REFRESH_ACTIVE_STOCK_DETAIL = 'REFRESH_ACTIVE_STOCK_DETAIL'
export const ACTIVE_TRADE_STOCK = 'ACTIVE_TRADE_STOCK'
export const RESTORE_STOCKS = 'RESTORE_STOCKS'
export const CLEAR_TRADE_STOCKS = 'CLEAR_TRADE_STOCKS'
export const UPDATE_TRADE_ACTIVE_TAB_ID = 'UPDATE_TRADE_ACTIVE_TAB_ID'
export const UPDATE_DOM_SCROLLABLE = 'UPDATE_DOM_SCROLLABLE'

export const DELETE_FROM_WATCHLIST = 'watchlist/delete'
export const INIT_WATCHLIST = 'watchlist/init'
export const UPDATE_WATCHLIST = 'watchlist/update'
export const CLEAR_WATCHLIST = 'watchlist/clear'
export const ADD_WATCHLIST_NOTIFY = 'watchlist/notify/add'
export const REMOVE_WATCHLIST_NOTIFY = 'watchlist/notify/remove'
export const UPDATE_WATCHLIST_DISPLAY = 'watchlist/display'
export const INIT_WATCHLIST_HOLDING_LIST = 'watchlist/holding/init'
export const UPDATE_WATCHLIST_HOLDING_LIST = 'watchlist/holding/update'
export const UPDATE_WATCHLIST_HOLDING_COR_ACTION =
  'watchlist/holding/cor_action'
export const UPDATE_WATCHLIST_GROUP = 'watchlist/group/update'
export const UPDATE_WATCHLIST_MARKET = 'watchlist/market/update'

// Watchlist Groups
export const LOAD_GROUP_LIST = 'LOAD_GROUP_LIST'
export const BOOKMARK_PROMPT = 'BOOKMARK_PROMPT'
export const CLEAR_BOOKMARK_PROMPT = 'CLEAR_BOOKMARK_PROMPT'
export const SAVE_STOCKS_TO_ADD = 'SAVE_STOCKS_TO_ADD'
export const CLEAR_ADD_STOCKS_GROUP = 'CLEAR_ADD_STOCKS_GROUP'
export const TOGGLE_BOOKMARK_MANAGER = 'TOGGLE_BOOKMARK_MANAGER'
export const SET_CURRENT_GROUP = 'SET_CURRENT_GROUP'
export const CLEAR_CURRENT_GROUP = 'CLEAR_CURRENT_GROUP'
export const SHOW_GROUP_MODIFY = 'SHOW_GROUP_MODIFY'

export const RESTORE_CACHE_USER = 'RESTORE_CACHE_USER'
export const UPDATE_USER_IDENTITY = 'account/update_identity'
export const UPDATE_USER_INFO = 'account/update_user_info'
export const UPDATE_ACCOUNT_STATUS = 'account/update_status'
export const UPDATE_ACCOUNT_INFO = 'account/update_customer_info'
export const UPDATE_ACCOUNT_PROCESS_INFO = 'account/update_process'
export const UPDATE_PERMISSION = 'account/update_permission'

export const CLEAR_USER_INFO = 'clear/user_info'
export const CLEAR_USER_SETTINGS = 'clear/user_settings'

export const REFRESH_USER_TOKEN = 'user/refresh_auth_token'
export const UPDATE_USER_TOKEN = 'user/update_auth_token'
export const UPDATE_USER_ASSET = 'user/update_asset'
export const UPDATE_USER_HOLDINGS_LIST = 'user/update_holdings'
export const UPDATE_USER_TRADE_TOKEN = 'user/update_trade_token'
export const UPDATE_EXCHANGE_RATE = 'user/update_exchange_rate'
export const UPDATE_USER_VIEWS = 'UPDATE_USER_VIEWS'

export const UPDATE_USER_SETTING = 'user/update_settings'

export const SET_LOGIN_TIME = 'SET_LOGIN_TIME'

// Timeline, news and posts
export const APPEND_TO_NEWS_LIST_TIMELINE = 'APPEND_TO_NEWS_LIST_TIMELINE'
export const EMPTY_NEWS_LIST_TIMELINE = 'EMPTY_NEWS_LIST_TIMELINE'
export const APPEND_TO_POSTS_LIST_TIMELINE = 'APPEND_TO_POSTS_LIST_TIMELINE'
export const EMPTY_POSTS_LIST_TIMELINE = 'EMPTY_POSTS_LIST_TIMELINE'
export const APPEND_NEWS_LETTER = 'APPEND_NEWS_LETTER'

// Discovery Data
export const LOAD_DISCOVERY_DATA = 'LOAD_DISCOVERY_DATA'
export const CLEAR_DISCOVERY_DATA = 'CLEAR_DISCOVERY_DATA'
export const SET_DISCOVERY_SIDE_LIST = 'SET_DISCOVERY_SIDE_LIST'
export const UPDATE_CURRENT_DATE = 'UPDATE_CURRENT_DATE'
export const SET_DISCOVEY_FILTERS = 'SET_DISCOVEY_FILTERS'

// Brief Data
export const LOAD_BRIEF_DATA = 'LOAD_BRIEF_DATA'
export const CLEAR_BRIEF_DATA = 'CLEAR_BRIEF_DATA'

// Metrics Data
export const LOAD_METRICS_SHORT_DATA = 'LOAD_METRICS_SHORT_DATA'
export const CLEAR_METRICS_SHORT_DATA = 'CLEAR_METRICS_SHORT_DATA'

// Stream Page
export const UPDATE_QUOTE_POST = 'UPDATE_QUOTE_POST'
// Financial Info
export const LOAD_FINANCIAL_DATA = 'LOAD_FINANCIAL_DATA'

// RankList
export const LOAD_RANK_LIST_UNUSUAL = 'LOAD_RANK_LIST_UNUSUAL'
export const UPDATE_RANK_LIST_ITEM = 'UPDATE_RANK_LIST_ITEM'

// Notifications
export const ADD_NOTIFY = 'ADD_NOTIFY'
export const REMOVE_NOTIFY = 'REMOVE_NOTIFY'
export const CLEAR_NOTIFIES = 'CLEAR_NOTIFIES'

// Trade
export const UPDATE_ORDER = 'trade/update_order'
export const REMOVE_TRADE_REQUEST = 'trade/remove_request'
export const NEW_TRADE_REQUEST = 'trade/new_request'
export const UPDATE_TRADE_STOCK = 'trade/update_request'
export const RESET_TRADE_DOMSCROLLABLE = 'trade/reset_dom_scrollable'
export const UPDATE_TRADE_ORDER = 'trade/update_order'

// Orders
export const SET_OPEN_ORDERS = 'order/set_open_orders'
export const SET_DEAL_ORDERS = 'order/set_deal_orders'
export const SET_CANCELED_ORDERS = 'order/set_cancel_orders'
export const REFRESH_OPEN_ORDERS = 'order/refresh_open_orders'
export const SET_CUR_STOCK_HOLDINGS = 'order/set_cur_holdings'
export const SET_CUR_STOCK_ORDERS = 'order/set_cur_orders'
export const LATEST_ORDER_STATUS = 'order/set_latest_status'

// Options
export const SAVE_OPTION_CHAIN = 'SAVE_OPTION_CHAIN'
export const SET_CHOSED_OPTION = 'SET_CHOSED_OPTION'
export const SET_USER_STATUS = 'SET_USER_STATUS'

// multiviews
export const INIT_OPEN_STOCK_LIST = 'INIT_OPEN_STOCK_LIST'
export const SET_STOCK_TO_OPEN_LIST = 'SET_STOCK_TO_OPEN_LIST'
export const SET_ACTIVE_VIEW_SLOT = 'SET_ACTIVE_VIEW_SLOT'
export const RE_ORDER_VIEW_LIST = 'RE_ORDER_VIEW_LIST'
export const SYNC_LOCK_DATA = 'SYNC_LOCK_DATA'
export const REFRESH_VIEW_STOCK_DETAIL = 'REFRESH_VIEW_STOCK_DETAIL'

// kchart
export const SET_STUDY = 'SET_STUDY'
export const UPDATE_STUDY = 'UPDATE_STUDY'
export const INIT_STUDY = 'INIT_STUDY'

// assets
export const FETCH_ACCOUNT_ANALYZE = 'FETCH_ACCOUNT_ANALYZE'
export const DELETE_USER_HOLDING_ASSET = 'clear/user_holdings_assets'

// mqtt
export const MQTT_CONNECT = 'mqtt/connect'
export const MQTT_DISCONNECT = 'mqtt/disconnect'

// sideEffects 副作用模块相关
export const SET_ORDER_DETAIL = 'SET_ORDER_DETAIL'

// 个人信息面板展示
export const SHOW_ACCOUNT_INFO = 'SHOW_ACCOUNT_INFO'
export const UPDATE_CONTEST_TIP_FLAG = 'UPDATE_CONTEST_TIP_FLAG'

// 股票侧边栏
export const SHOW_SIDE_STOCK_VIEW = 'SHOW_SIDE_STOCK_VIEW'
export const CLOSE_SIDE_STOCK_VIEW = 'CLOSE_SIDE_STOCK_VIEW'
export const UPDATE_SIDE_STOCK = 'UPDATE_SIDE_STOCK'

// 浏览历史
export const ADD_HISTORY_STOCK = 'ADD_HISTORY_STOCK'
export const UPDATE_HISTORY_STOCK = 'UPDATE_HISTORY_STOCK'
export const INIT_HISTORY_LIST = 'INIT_HISTORY_LIST'
export const CLEAR_HISTORY_LIST = 'CLEAR_HISTORY_LIST'

// 新闻模块
export const UPDATE_NEWS_STOCKS = 'news/update_stock'

// 热力图
export const UPDATE_HEAT_MAP_DATA = 'UPDATE_HEAT_MAP_DATA'
export const UPDATE_ACTIVE_INDUSTRY = 'UPDATE_ACTIVE_INDUSTRY'
export const UPDATE_HEAT_MAP_COND = 'UPDATE_HEAT_MAP_COND'

// 股价提醒
export const DELETE_PRICE_ALERT = 'price_alert/delete'
export const UPDATE_PRICE_ALERT_LIST = 'price_alert/update_list'
export const SWITCH_PRICE_ALERT_TAB = 'price_alert/switch_tab'
export const UPDATE_PRICE_ALERT_STOCK = 'price_alert/update_stock'
export const UPDATE_PRICE_ALERT_ALL = 'price_alert/update_all'
export const UPDATE_PRICE_ALERT_CUR = 'price_alert/update_cur'
export const UPDATE_PRICE_ALERT_EDIT = 'price_alert/update_edit'

// 消息中心
export const UPDATE_MSG_UNREAD_COUNT = 'message/update_unread_count'
export const UPDATE_MSG_CUR_ID = 'message/update_cur_id'
export const UPDATE_MSG_VISIBLE = 'message/show_modal'

export const UPDATE_ACCOUNT_VISIBLE = 'UPDATE_ACCOUNT_VISIBLE'
